import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NoBaskets from './NoBaskets'
import BasketsList from './BasketsList'
import {Spin} from 'antd'

class BasketsTable extends Component {
    _renderTableContent = () => {
        const {baskets} = this.props

        if (baskets.length === 0) {
            return <NoBaskets/>
        }

        return <BasketsList baskets={baskets}/>
    }


    render() {
        const tableContent = this._renderTableContent()
        const {loading} = this.props

        return (
            <div className='BasketsTable'>
                <Spin spinning={loading} tip='Loading...'>
                    <table className='table table-borderless table-striped'>
                        <thead className='thead-light'>
                        <tr>
                            <th>Số giỏ</th>
                            <th>Mã đơn</th>
                            <th>Loại sản phẩm</th>
                            <th>Loại đơn</th>
                            <th>Loại giỏ</th>
                            <th className='text-center'>Chưa hoàn thành / Đã hoàn thành</th>
                            <th>Địa chỉ</th>
                            <th>Trạng thái</th>
                            <th>Ngày tạo</th>
                            <th>Ngày hoàn thành</th>
                            <th>Item cuối cùng</th>
                        </tr>
                        </thead>
                        <tbody>
                        {tableContent}
                        </tbody>
                    </table>
                </Spin>
            </div>
        )
    }
}

BasketsTable.propTypes = {
    baskets: PropTypes.array.isRequired,
}

export default BasketsTable
